import { useQuery } from "@tanstack/react-query";
import { UseFormRegister, UseFormReturn, useWatch } from "react-hook-form";

import brandCore from "../../core/brand.core";
import localeCore from "../../core/locale.core";
import materialCore from "../../core/material.core";
import { useTranslation } from "../../core/translation.core";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import LocalePs from "../locale/localePs.core";
import { selectCss } from "../reuseables/native.comp";

interface MaterialTypeProps {
  methods: UseFormReturn<{ materialTypeId: string }, any>;
}

export default function MaterialTypeSelector({ methods }: MaterialTypeProps) {
  const { t, msg } = useTranslation();
  const materialTypeId = useWatch({ control: methods.control, name: "materialTypeId" });
  return (
    <div className="my-8 border p-4">
      <div className="block text-base font-semibold mb-2">{t(msg.material.materialType)}</div>

      <div id="materialTypeId-list">
        <div>
          <MaterialTypes register={methods.register} />
        </div>
      </div>
    </div>
  );
}

function useMaterialType() {
  return useQuery({
    queryKey: ["material-type"],
    queryFn: () => materialCore.materialType.getList(),
  });
}

interface MaterialTypesProps {
  register: UseFormRegister<{ materialTypeId: string }>;
}

function MaterialTypes({ register }: MaterialTypesProps) {
  const { data, isLoading, error, isError } = useMaterialType();

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;
  if (!data) return null;

  return (
    <div className="grid grid-cols-1 gap-6 sm:gap-0 sm:grid-cols-[150px_auto] items-start py-3">
      <div>
        <select className={`${selectCss} text-xs h-[40px]`} {...register(`materialTypeId`)}>
          <option></option>
          {data.map((brand) => (
            <option key={brand.id} value={brand.id}>
              {brand.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
